import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import axios from 'axios'; // Import axios for API requests
import DigiDocImage from '../../Assets/Images/DigiDoc Head.png';
import SplashImage from '../../Assets/Images/Online Doctor-amico.png';
import config from '../../Config'; // Assuming config has the API base URL
import './MappingScreen.css';

const MappingScreen = () => {
    const [selectedMap, setSelectedMap] = useState(null);
    const [isLoading, setIsLoading] = useState(false); // Track loading state for API
    const [error, setError] = useState(null); // Track errors
    const navigate = useNavigate();

    // Get patient_id, prescription_id, and token from sessionStorage
    const patientId = sessionStorage.getItem('patientid');
    const prescriptionId = sessionStorage.getItem('prescription_id');
    const token = sessionStorage.getItem('authToken'); // Assuming the token is saved in sessionStorage

    // Handle map selection and navigate to relevant page or make API call
    const handleMapSelect = async (map) => {
        setSelectedMap(map);
        setIsLoading(true); // Set loading state to true

        if (map === 'Map Medicine') {
            navigate('/map-medicine'); // Navigate to /map-medicine
        } else if (map === 'Auto Map') {
            if (patientId && prescriptionId) {
                try {
                    // Make API request to trigger auto-map with Authorization header
                    const response = await axios.get(
                        `${config.API_BASE_URL}/patient/automap/${patientId}/${prescriptionId}`,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`, // Add token to Authorization header
                            },
                        }
                    );

                    // If API request is successful, navigate to the success screen
                    if (response.status === 200) {
                        navigate('/automapsuccess'); // Redirect to auto map success page
                    } else {
                        setError("Failed to map the medicines. Please try again.");
                    }
                } catch (error) {
                    // Handle error if API call fails
                    if (error.response && error.response.status === 401) {
                        setError("Unauthorized access: No token provided or token expired.");
                    } else {
                        setError("An error occurred while setting up the regimen.");
                    }
                    console.error(error);
                } finally {
                    setIsLoading(false); // Set loading state to false
                }
            } else {
                setError("Missing patient or prescription data.");
                setIsLoading(false);
            }
        }
    };

    // Helper function for dynamically applying class names
    const getButtonClass = (map) => {
        return `map-button ${map} ${selectedMap === map ? 'selected' : ''}`;
    };

    return (
        <div className="language-container">
            <header className="logo-section">
                <img src={DigiDocImage} alt="DigiDoc" className="logo" />
            </header>
            <div className="illustration-section">
                <img src={SplashImage} alt="Doctor Illustration" className="illustration" />
            </div>
            <div className="language-selector">
                <div className="divider"></div>
                
                <h4>Map your uploaded medicine photos with their corresponding medicines?</h4>
                
                <div className="button-group">
                    <button
                        className={getButtonClass('Map Medicine')}
                        onClick={() => handleMapSelect('Map Medicine')}
                    >
                        Map Medicine
                    </button>
                    <button
                        className={getButtonClass('Auto Map')}
                        onClick={() => handleMapSelect('Auto Map')}
                        disabled={isLoading} // Disable button while loading
                    >
                        Auto Map
                    </button>
                </div>
                
                {isLoading && <div className="loading-message">Mapping in progress...</div>}
                {error && <div className="error-message">{error}</div>}
            </div>
        </div>
    );
};

export default MappingScreen;
